"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateAtEndOfDay = exports.getDateAtStartOfDay = exports.getPlaceholder = exports.validateInputLabelAccessibility = void 0;
var validateInputLabelAccessibility = function (componentName, label, ariaLabel) {
    if (!label && !ariaLabel) {
        console.warn("".concat(componentName, ": For accessibility, a label or aria-label property must be sent."));
    }
};
exports.validateInputLabelAccessibility = validateInputLabelAccessibility;
var getPlaceholder = function (placeholder, hasStartAdornment) {
    if (placeholder) {
        return placeholder;
    }
    if (hasStartAdornment) {
        return '';
    }
    return ' ';
};
exports.getPlaceholder = getPlaceholder;
var getDateAtStartOfDay = function (date) {
    return new Date(new Date(date).setHours(0, 0, 0, 0));
};
exports.getDateAtStartOfDay = getDateAtStartOfDay;
var getDateAtEndOfDay = function (date) {
    return new Date(new Date(date).setHours(23, 59, 59, 999));
};
exports.getDateAtEndOfDay = getDateAtEndOfDay;
